export default [
    {
        path: '/new-streams',
        name: 'PageNewStreamsList',
        meta: { title: 'newStreams.listTitle', roles: ['ADMIN', 'TEAM_LEADER'], permissions: ['new_streams'] },
        component: () => import('@/pages/new-streams'),
    },
]
